import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import { Dispatch } from 'redux';
import AlertContainer from '../components/alerts/AlertContainer';
import { themeBackgroundImage } from '../stores/auth/selectors';
import { RootState } from '../stores/store';

interface Props extends RouteComponentProps, LocalizeContextProps {
    title?: string;
    // tslint:disable-next-line:no-any
    component: React.ComponentType<any>;
    rest?: {
        // tslint:disable-next-line:no-any
        [key: string]: any,
    };
}

class PublicRoute extends React.Component<Props> {

    public render() {
        if (this.props.title !== undefined && document.title !== this.props.title) {
            document.title = this.props.title;
        }
        return (
            <Route
                {...this.props.rest}
                render={(props) => (
                    <React.Fragment>
                        <div>
                            <this.props.component {...props} />
                        </div>
                    </React.Fragment>
                )}
            />
        );
    }
}

const mapStateToProps = (
    state: RootState,
    { component: Component, ...rest }:
        // tslint:disable-next-line:no-any
        { component: React.ComponentType<any>, [key: string]: any }
) =>
    ({
        component: Component,
        rest,
    });

const mapDispatchToProps = (dispatch: Dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(PublicRoute)));
